module.exports = __webpack_public_path__ + "img/bretzel-games.551943fb.png";